import { Download } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'

interface Period {
  id: string
  label: string
}

interface ReportsHeaderProps {
  selectedPeriod: string
  periods: Period[]
  onPeriodChange: (periodId: string) => void
  onExport?: () => void
}

export function ReportsHeader({
  selectedPeriod,
  periods,
  onPeriodChange,
  onExport
}: ReportsHeaderProps) {
  const { t } = useTranslation()

  return (
    <div className="bg-white border-b border-gray-100 p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-text-primary">{t('navigation.reports')}</h1>
        <Button variant="outline" size="sm" onClick={onExport}>
          <Download className="h-4 w-4 mr-2" />
          {t('common.export')}
        </Button>
      </div>

      {/* Period Selector */}
      <div className="flex bg-gray-100 rounded-lg p-1">
        {periods.map((period) => (
          <button
            key={period.id}
            onClick={() => onPeriodChange(period.id)}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
              selectedPeriod === period.id
                ? 'bg-white text-primary shadow-sm'
                : 'text-text-secondary'
            }`}
          >
            {period.label}
          </button>
        ))}
      </div>
    </div>
  )
}

